// extracted by mini-css-extract-plugin
export default {"sellerSegmentation":"styles_sellerSegmentation__SMp0H"};